<template>
  <div dir="rtl">
    <div v-if="isLoading" class="loading"></div>
    <div v-else class="columns">
      <div class="column is-5">
        <div>
          <p class="bold">חוזים קיימים: <span v-if="files.length == 0" class="has-text-danger mx-6">אין חוזים</span></p>
          <div v-for="file in files" :key="file.name" class="is-flex is-align-items-center mt-5">
            <button class="button file_link" @click="openFile(file)" target="_blank">
              {{ file.name + ' ' + $moment(file.uploaded_at).format('DD/MM/YYYY') }}
            </button>
            <div class="is-flex is-align-items-center">
              <button @click="editFile(file)" class="button is-outlined is-info">Edit</button>
            </div>
          </div>
        </div>
        <div class="is-flex is-justify-content-flex-start mt-6">
          <button @click="uploadFile" class="button is-info">Upload File</button>
        </div>
      </div>
      <div v-if="files.length > 0" class="column">
        <PreviewFile :payload="{ fileName: lastContract.name, company_id: payload.company_id }" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import PreviewFile from '@/components/PreviewFile'
export default {
  name: 'files-company-contracts',
  components: {
    PreviewFile
  },
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isLoading: true,
      files: []
    }
  },
  computed: {
    lastContract () {
      return [...this.files].sort((a, b) => new Date(b.uploaded_at) - new Date(a.uploaded_at))[0]
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.isLoading = true
      const accountingCompany = await this.$network_utils.getAccountingCompany({ env: this.$settings.get({ path: 'operation_name' }), env_company_id: this.payload.company_id })
      if (!accountingCompany) {
        this.createAccountingCompany()
        return
      }
      this.getFiles()
    },
    createAccountingCompany () {
      this.create({
        designator: 'accounting-company-form-modal',
        component_name: 'AccountingCompanyForm',
        company: this.payload,
        is_modal: true,
        modal_title: 'Accounting Company',
        props: {
          onCloseSelectCompany: data => {
            this.getFiles()
          }
        }
      })
    },
    async getFiles () {
      const response = await this.$network_utils.getFiles({ env: this.$settings.get({ path: 'operation_name' }), env_id: this.payload.company_id, is_contract: true })
      this.files = response
      this.isLoading = false
    },
    uploadFile () {
      this.create({
        designator: 'upload-file-modal',
        component_name: 'UploadFileForm',
        company: { env: this.$settings.get({ path: 'operation_name' }), env_id: this.payload.company_id },
        modal_title: 'העלאת קבצים',
        refresh: this.init
      })
    },
    openFile (file) {
      this.$network_utils
        .getFile({
          file_name: file.name,
          env: this.$settings.get({ path: 'operation_name' }),
          env_id: this.payload.company_id,
          is_contract: true
        })
        .then(response => {
          let blob_file = new Blob([response], { type: 'application/pdf' })
          let blob_file_url = URL.createObjectURL(blob_file)
          let file_viewer_window = window.open(blob_file_url)
          setTimeout(function () {
            file_viewer_window.document.title = this.file.name
          }, 100)
        })
    },
    editFile (file) {
      this.create({
        designator: 'file-editor',
        component_name: 'FileEditor',
        modal_title: 'Edit File - ' + file.name,
        file: file,
        env: this.$settings.get({ path: 'operation_name' }),
        env_id: this.payload.company_id,
        is_contract: true,
        refresh: this.init
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
